function initProjectsMap() {
    const root = document.getElementById('projects-map-container');
    if (!root) {
        return;
    }

    const GOOGLE_MAPS_API_KEY = root.dataset.mapsKey || '';
    const GOOGLE_MAPS_MAP_ID = root.dataset.mapId || '';
    const MAP_MARKER_ICON = root.dataset.mapsMarkerIcon || '';

    let projectsMap = null;
    let projectsMapMarkers = [];
    let projectsMapInfoWindow = null;
    let mapVisible = false;
    let mapRequestInFlight = false;
    let googleMapsLoaded = false;
    let googleMapsLoading = false;
    let markerClustererLibLoaded = false;
    let clusterInstance = null;

    function setMapLoading(isLoading) {
        const loader = document.getElementById('projects-map-loader');
        if (!loader) {
            return;
        }
        loader.style.display = isLoading ? 'flex' : 'none';
    }

    function loadGoogleMapsScript(callback) {
        if (googleMapsLoaded && markerClustererLibLoaded) {
            callback();
            return;
        }
        if (googleMapsLoading) {
            const iv = setInterval(function () {
                if (googleMapsLoaded && markerClustererLibLoaded) {
                    clearInterval(iv);
                    callback();
                }
            }, 100);
            return;
        }
        googleMapsLoading = true;
        setMapLoading(true);
        window._onGoogleMapsReady = function () {
            googleMapsLoaded = true;
            const cs = document.createElement('script');
            cs.src = 'https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js';
            cs.onload = function () {
                markerClustererLibLoaded = true;
                googleMapsLoading = false;
                setMapLoading(false);
                callback();
            };
            cs.onerror = function () {
                markerClustererLibLoaded = true;
                googleMapsLoading = false;
                setMapLoading(false);
                callback();
            };
            document.head.appendChild(cs);
        };
        const s = document.createElement('script');
        s.src =
            'https://maps.googleapis.com/maps/api/js?key=' +
            encodeURIComponent(GOOGLE_MAPS_API_KEY) +
            '&libraries=marker&loading=async&callback=_onGoogleMapsReady';
        s.async = true;
        s.defer = true;
        document.head.appendChild(s);
    }

    function restoreMapButtonState() {
        const btn = document.getElementById('map-toggle-btn');
        const icon = document.getElementById('map-toggle-icon');
        if (!btn || !icon) {
            return;
        }

        if (mapVisible) {
            btn.classList.add('bg-blue-600', 'text-white', 'shadow-md');
            btn.classList.remove('bg-white', 'text-gray-700');
            icon.classList.remove('fa-chevron-down');
            icon.classList.add('fa-chevron-up');
        } else {
            btn.classList.remove('bg-blue-600', 'text-white', 'shadow-md');
            btn.classList.add('bg-white', 'text-gray-700');
            icon.classList.remove('fa-chevron-up');
            icon.classList.add('fa-chevron-down');
        }
    }

    function clearMapMarkers() {
        if (clusterInstance) {
            clusterInstance.clearMarkers();
            clusterInstance = null;
        }
        for (let i = 0; i < projectsMapMarkers.length; i++) {
            if (typeof projectsMapMarkers[i].setMap === 'function') {
                projectsMapMarkers[i].setMap(null);
            } else {
                projectsMapMarkers[i].map = null;
            }
        }
        projectsMapMarkers = [];
        if (projectsMapInfoWindow) {
            projectsMapInfoWindow.close();
        }
    }

    function loadMapData() {
        if (!mapVisible || !projectsMap || mapRequestInFlight) {
            return;
        }
        if (typeof oc === 'undefined' || !oc.ajax) {
            return;
        }

        mapRequestInFlight = true;
        setMapLoading(true);
        const params = new URLSearchParams(window.location.search);
        const data = {};
        params.forEach(function (value, key) {
            data[key] = value;
        });

        oc.ajax('onMapData', {
            data: data,
            success: function (response) {
                mapRequestInFlight = false;
                clearMapMarkers();
                if (response.mapData && response.mapData.length > 0) {
                    placeMarkers(response.mapData);
                }
                setMapLoading(false);
            },
            error: function () {
                mapRequestInFlight = false;
                setMapLoading(false);
            },
        });
    }

    function placeMarkers(stations) {
        const bounds = new google.maps.LatLngBounds();
        let placed = 0;

        function fitIfReady() {
            if (placed === 0) {
                return;
            }

            const MC =
                window.markerClusterer && window.markerClusterer.MarkerClusterer
                    ? window.markerClusterer.MarkerClusterer
                    : null;

            if (MC) {
                clusterInstance = new MC({
                    map: projectsMap,
                    markers: projectsMapMarkers,
                });
            } else {
                for (let j = 0; j < projectsMapMarkers.length; j++) {
                    if (typeof projectsMapMarkers[j].setMap === 'function') {
                        projectsMapMarkers[j].setMap(projectsMap);
                    } else {
                        projectsMapMarkers[j].map = projectsMap;
                    }
                }
            }

            if (projectsMapMarkers.length === 1) {
                const markerLatLng = getMarkerLatLng(projectsMapMarkers[0]);
                if (markerLatLng) {
                    projectsMap.setCenter(markerLatLng);
                }
                projectsMap.setZoom(14);
            } else if (projectsMapMarkers.length > 1) {
                projectsMap.fitBounds(bounds);
            }
        }

        for (let i = 0; i < stations.length; i++) {
            const station = stations[i];
            if (typeof station.lat !== 'number' || typeof station.lng !== 'number') {
                continue;
            }

            const pos = {
                lat: station.lat,
                lng: station.lng,
            };
            addMarker(station, pos);
            bounds.extend(new google.maps.LatLng(pos.lat, pos.lng));
            placed++;
        }

        fitIfReady();
    }

    function escapeHtml(text) {
        const d = document.createElement('div');
        d.textContent = text;
        return d.innerHTML;
    }

    function getMarkerLatLng(marker) {
        if (typeof marker.getPosition === 'function') {
            return marker.getPosition();
        }
        const p = marker.position;
        if (p && typeof p.lat === 'function' && typeof p.lng === 'function') {
            return p;
        }
        if (p && typeof p.lat === 'number' && typeof p.lng === 'number') {
            return new google.maps.LatLng(p.lat, p.lng);
        }
        return null;
    }

    function addMarker(station, position) {
        let marker = null;
        const markerTitle = station.store_name + ' (' + station.store_id + ')';
        const hasAdvancedMarker =
            !!GOOGLE_MAPS_MAP_ID &&
            google.maps &&
            google.maps.marker &&
            google.maps.marker.AdvancedMarkerElement;

        if (hasAdvancedMarker) {
            const pin = document.createElement('div');
            pin.style.width = '32px';
            pin.style.height = '32px';
            pin.style.backgroundSize = 'contain';
            pin.style.backgroundRepeat = 'no-repeat';
            pin.style.backgroundPosition = 'center';
            pin.style.transform = 'translateY(-8px)';
            pin.style.cursor = 'pointer';
            pin.style.pointerEvents = 'auto';
            if (MAP_MARKER_ICON) {
                pin.style.backgroundImage = 'url("' + MAP_MARKER_ICON + '")';
            }
            marker = new google.maps.marker.AdvancedMarkerElement({
                position: position,
                title: markerTitle,
                content: pin,
            });
        } else {
            const markerOpts = {
                position: position,
                title: markerTitle,
            };
            if (MAP_MARKER_ICON) {
                markerOpts.icon = {
                    url: MAP_MARKER_ICON,
                    scaledSize: new google.maps.Size(32, 32),
                };
            }
            marker = new google.maps.Marker(markerOpts);
        }

        marker.projectId = station.project_id;

        const openInfoWindow = function () {
            const directionsUrl =
                'https://www.google.com/maps/dir/?api=1&destination=' +
                encodeURIComponent(String(position.lat) + ',' + String(position.lng));
            const content =
                '<div style="max-width:280px;padding:4px">' +
                '<div style="font-size:13px;margin-bottom:2px">Store ID: ' +
                escapeHtml(station.store_id) +
                '</div>' +
                '<div style="font-size:13px;margin-bottom:2px">Store Name: ' +
                escapeHtml(station.store_name) +
                '</div>' +
                '<div style="font-size:13px;margin-bottom:2px">Project Start: ' +
                escapeHtml(station.project_start || 'N/A') +
                '</div>' +
                '<a href="' +
                escapeHtml(station.edit_url || '#') +
                '" style="color:#2563eb;font-size:13px;text-decoration:underline">Open Project</a>' +
                '<span style="color:#9ca3af;margin:0 8px">|</span>' +
                '<a href="' +
                directionsUrl +
                '" target="_blank" rel="noopener noreferrer" style="color:#2563eb;font-size:13px;text-decoration:underline">Navigate to</a>' +
                '</div>';
            projectsMapInfoWindow.setContent(content);
            projectsMapInfoWindow.open({
                map: projectsMap,
                anchor: marker,
            });
        };
        marker._openInfoWindow = openInfoWindow;
        if (hasAdvancedMarker) {
            if (typeof marker.addEventListener === 'function') {
                marker.addEventListener('gmp-click', openInfoWindow);
            }
            if (marker.content && typeof marker.content.addEventListener === 'function') {
                marker.content.addEventListener('click', openInfoWindow);
            }
        } else {
            marker.addListener('click', openInfoWindow);
        }

        projectsMapMarkers.push(marker);
    }

    function findMarkerByProjectId(projectId) {
        for (let i = 0; i < projectsMapMarkers.length; i++) {
            if (projectsMapMarkers[i].projectId === projectId) {
                return projectsMapMarkers[i];
            }
        }
        return null;
    }

    function centerOnMarker(marker) {
        const markerLatLng = getMarkerLatLng(marker);
        if (markerLatLng) {
            projectsMap.setCenter(markerLatLng);
        }
        projectsMap.setZoom(14);
        if (typeof marker._openInfoWindow === 'function') {
            marker._openInfoWindow();
        }
        const container = document.getElementById('projects-map-container');
        if (container) {
            container.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    window.toggleProjectsMap = function () {
        const container = document.getElementById('projects-map-container');

        if (mapVisible) {
            container.style.display = 'none';
            mapVisible = false;
            restoreMapButtonState();
        } else {
            container.style.display = 'block';
            mapVisible = true;
            restoreMapButtonState();

            loadGoogleMapsScript(function () {
                if (!projectsMap) {
                    projectsMap = new google.maps.Map(document.getElementById('projects-map'), {
                        center: { lat: 56.9, lng: 24.1 },
                        zoom: 7,
                        mapTypeControl: true,
                        streetViewControl: false,
                        mapId: GOOGLE_MAPS_MAP_ID || undefined,
                    });
                    projectsMapInfoWindow = new google.maps.InfoWindow();
                } else {
                    google.maps.event.trigger(projectsMap, 'resize');
                }
                loadMapData();
            });
        }
    };

    window.showOnMap = function (projectId) {
        if (!mapVisible) {
            window.toggleProjectsMap();
            let attempts = 0;
            const checkInterval = setInterval(function () {
                attempts++;
                const marker = findMarkerByProjectId(projectId);
                if (marker) {
                    clearInterval(checkInterval);
                    centerOnMarker(marker);
                }
                if (attempts > 50) {
                    clearInterval(checkInterval);
                }
            }, 300);
        } else {
            const marker = findMarkerByProjectId(projectId);
            if (marker) {
                centerOnMarker(marker);
            }
        }
    };

    window.addEventListener('ajax:update-complete', function () {
        if (mapRequestInFlight) {
            return;
        }
        if (mapVisible && projectsMap) {
            setTimeout(loadMapData, 400);
        }
        setTimeout(restoreMapButtonState, 50);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProjectsMap);
} else {
    initProjectsMap();
}
